<template>
  <div id="app">
    <noticetop></noticetop>
    <router-view/>
  </div>
</template>

<script>
import noticetop from '@/components/noticetop'
export default {
  name: 'App',
  components: {
    noticetop,
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 10px 20px;
}
.md-scroll-view .scroll-view-container.horizon {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue